// Shared constants of the tenant GPU servers pages. Provider-free by rule: no file under
// src/app/Datacenter/GpuServers may name the upstream provider.

/**
 * The SSH login user shown as `ssh <user>@<ip>` on the detail page — a FRONTEND assertion, not part
 * of the backend contract (the API exposes no user name). It comes from the provider's public
 * "connect to your server" docs, which say the user can vary by OS image; to be confirmed for every
 * image offered before launch — set to null to hide the hint (only the IP and the keys note remain).
 */
export const GPU_SERVER_SSH_USER: string | null = 'root';

/**
 * The per-organisation cap on active (non-terminal) servers — `starting`, `unpaid` and `deleting`
 * servers count too. Mirrors `offer.max_servers`, which only the start wizard loads (the offer is a
 * live read, so the list page never fetches it); the backend enforces the real cap.
 */
export const GPU_SERVER_MAX_ACTIVE = 5;

/** Why Start / Delete are disabled during a staff impersonation session (the backend refuses both). */
export const GPU_SERVER_IMPERSONATION_NOTICE =
  'You are viewing this organisation through an impersonation session. Starting or deleting GPU servers is not available here (staff: use the admin area).';
